const cartNotification = document.querySelector("cart-notification");
    
/*********** Add to Cart Variants ***********/
// Open and close variant selector for Desktop and Mobile.
let products = document.querySelectorAll('.productCard.hasVariants')
if(window.innerWidth > 767){ // Open variant hoverwith products with multiple variants for Desktop.
    products.forEach(product => {
        let productCTA = product.querySelector('.cartContainer')
        let productMedia = product.querySelector('.mediaWrapper')
        let productCardNodes = [productCTA];

        productCardNodes.forEach(node => {
        node.addEventListener('mouseover', function(e){
            product.querySelector('.cartModal').classList.add('open')
        })       
        node.addEventListener('mouseout', function(e){
            product.querySelector('.cartModal').classList.remove('open')
        })       
        })
    })
}else{ // Open Modal with products with multiple variants for Mobile.
    products.forEach(product => {
    let productCTA = product.querySelector('.cartContainer')
    let productMedia = product.querySelector('.mediaWrapper')
    let productCardNodes = [productCTA, productMedia];

    productCardNodes.forEach(node => {
        if(node.querySelector('.backup-hasVariants')){
        // Open Modal
        node.querySelector('.backup-hasVariants').addEventListener('click', function(e){
            product.querySelector('.cartModal').classList.add('open');
        })
        
        // Close Modal
        node.querySelector('button.dialogCloseButton').addEventListener('click', function(e){
            product.querySelector('.cartModal').classList.remove('open')
        })
        }       
    })
    })
}

const addToCartElement = document.querySelector('body');
addToCartElement.addEventListener('click', (event) => {
    if (event.target.matches('.productCard button.backup-addToCart')) {
    addToCart(event.target.dataset.variantId, event.target);
    }
});

const addToCart = async (variantId, element) => {
    try {
    element.classList.add('loading');
    const json = await fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        Accept: `application/javascript`,
        },
        body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: cartNotification
            .getSectionsToRender()
            .map((section) => section.section), 
        sections_url: window.location.pathname,
        properties: {}
        }),
    }).then((response) => response.json());

    cartNotification.renderContents(json);

    element.classList.remove('loading');
    element.closest('.productCard').querySelector('.cartModal').classList.remove('open');

    // Check for AutoGift
    if (typeof window.runAutoGift === 'function') {
        window.runAutoGift();
    }

    // Check for AutoDonation
    if (typeof window.runAutoDonation === 'function') {
        window.runAutoDonation();
    }
    
    } catch (error) {
    console.error(error);
    }
}


/*********** Wishlist Variants ***********/
// Open and close wishlist selector for Desktop and Mobile.
let allProducts = document.querySelectorAll('.productCard.hasVariants');
allProducts.forEach(product => {
    let productWishBTN = product.querySelector('.wishContainer > button.wishlistButton')
    let productWishModal = product.querySelector('.wishContainer > .wishModal')
    let productWishModalClose = product.querySelector('.wishContainer > .wishModal button.dialogCloseButton')
    let backupProductWishButton = product.querySelector('button.backup-hasVariants-wishlist')

    if(window.innerWidth > 767){ // Open dropdown for variants for product wishlist for Desktop.
        // Show Dropdown
        productWishBTN.addEventListener('mouseover', function(e){
            productWishModal.classList.add('open')
            productWishModal.querySelector('.wishDialog').classList.add('open')
            product.querySelector('.cartModal')?.classList.add('wishlist-open')
        })
        product.querySelector('.wishDialog').addEventListener('mouseover', function(e){
            productWishModal.classList.add('open')
            productWishModal.querySelector('.wishDialog').classList.add('open')
            product.querySelector('.cartModal')?.classList.add('wishlist-open')
        })
        // Hide dropdown
        product.addEventListener('mouseout', function(e){
            productWishModal.classList.remove('open')
            productWishModal.querySelector('.wishDialog').classList.remove('open')
            product.querySelector('.cartModal')?.classList.remove('wishlist-open')
        })
        product.querySelector('.wishDialog').addEventListener('mouseout', function(e){
            productWishModal.classList.remove('open')
            productWishModal.querySelector('.wishDialog').classList.remove('open')
            product.querySelector('.cartModal').classList.remove('wishlist-open')
        })
    }else{
        productWishBTN.addEventListener('click', function(e){
            productWishModal.classList.add('open')
            productWishModal.querySelector('.wishDialog').classList.add('open');
            document.querySelector('body').classList.add('overflow-hidden');
        })
        productWishModalClose.addEventListener('click', function(e){
            productWishModal.classList.remove('open')
            productWishModal.querySelector('.wishDialog').classList.remove('open')
            document.querySelector('body').classList.remove('overflow-hidden');
        })

        //Mobile Add To Wishlist CTA

        backupProductWishButton.addEventListener('click', function(e){
            productWishModal.classList.add('open')
            productWishModal.querySelector('.wishDialog').classList.add('open')
            document.querySelector('body').classList.add('overflow-hidden');
        })

    }
})

const addToWishlistElement = document.querySelector('body');
addToWishlistElement.addEventListener('click', (event) => {
    if (event.target.matches('.productCard button.backup-addToWishlist')) {
    addToWishlist(event.target.dataset, event.target);
    document.body.classList.remove('overflow-hidden')
    }
});

const addToWishlist = async (dataset, element) => {
    const data = {
        epi: parseInt(dataset.variantId),
        empi: parseInt(dataset.productId),
        du: `${window.location.origin}/products/${dataset.handle}`,
        dt: dataset.productTitle,
        iu: dataset.image,
        pr: Number(dataset.price),
        vi: dataset.variantTitle, 
    }

    try {
        if(element.closest('.wishContainer').querySelector('.wishlistButton')){
            element.closest('.wishContainer').querySelector('.wishlistButton').classList.add('loading');
            await new Promise((resolve) =>
                window._swat.addToWishList(data, resolve)
            );
        }
    
    } catch (error) {
        console.error(error);
    }
    document.querySelector('.wishModal.open')?.classList.remove('open');
    element.closest('.wishContainer').querySelector('button > svg').innerHTML = '<path fill="currentColor" d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"></path>';
    if(document.querySelector('.wishContainer .loading'))
        document.querySelector('.wishContainer .loading').classList.remove('loading');
}


document.querySelectorAll('.backup-wishListButton').forEach((variantButton) => {
    variantButton.addEventListener('click', function(){
      let variantId = variantButton.getAttribute('data-variant-id');
      console.log(document.querySelector(`.dialogListItem[data-variant-id="${variantId}"]`));
      document.querySelector(`.dialogListItem[data-variant-id="${variantId}"]`).click();
    })
});